import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookieAccepted) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>We use cookies to enhance your experience. By continuing to browse this site, you agree to our use of cookies.</p>
        <div className="cookie-buttons">
          <Link to="/privacy" className="cookie-link">Learn More</Link>
          <button onClick={handleAccept} className="cookie-accept">Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
